// ActionButton.styles.tsx
import styled from "@emotion/styled";
import { ActionButtonWrapperProps } from "./ActionButton.types";
import { BORDER_RADIUS } from "../../utils/constants";
import { generateActionButtonStyles } from "../../utils";

export const ActionButtonWrapper = styled.button<
  ActionButtonWrapperProps & { hasIcon?: boolean }
>`
  appearance: none;
  border: none;
  cursor: pointer;
  border-radius: ${BORDER_RADIUS};
  padding: ${(props) => (props.hasIcon ? "2px 8px" : "7px 10px")};
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
  width: ${(props) => props.width || "auto"};
  ${(props) => generateActionButtonStyles(props)}
`;
